import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { SideNavigationIconLink } from '../../../../core/models/navigation-icon-link';

@Component({
    selector: 'app-sidenav-item-link',
    templateUrl: './sidenav-item-link.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [],
})
export class SidenavItemLinkComponent {
    @Input() item!: SideNavigationIconLink;
    @Input() isCollapsed!: boolean;
}
